import { useSelector } from 'react-redux';
import { Typography } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { setNavFromValue } from '@common/Tracking/NavFrom';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import { getLinkColor } from '../helpers/color';
import { getNavigationItemUrl } from '../helpers/url';
import { LeftNavigationItemCount } from './LeftNavigationItemCount';
import { LeftNavigationItemGroup } from './LeftNavigationItemGroup';
import '../styles/LeftNavigationItem.scss';

export function LeftNavigationItem({
    persistedFiltersGroup,
    item,
    trackingId,
    isLoneChild,
    isCountHidden
}) {
    const config = useConfig();
    const {
        productCount, selected, children
    } = item;
    const filters = useSelector(storeState => storeState.filters.activeFilters);
    const href = getNavigationItemUrl(item, persistedFiltersGroup, filters, config);
    const isExpanded = (selected || isLoneChild) && !!children.length;
    const linkColor = getLinkColor(item);

    return (
        <li className="left-navigation-item">
            <a
                className="left-navigation-item__link"
                href={href}
                onClick={() => setNavFromValue(trackingId)}
                onContextMenu={e => setNavFromValue(trackingId, e)}
            >
                <div>
                    <Typography
                        className="left-navigation-item__name"
                        color={linkColor}
                        tagName="span"
                        type="body"
                        weight={selected ? 'bold' : 'regular'}
                    >
                        {getTranslatedPropertyFromContext(item, 'name', config)}
                    </Typography>
                    {(!!productCount && !isCountHidden)
                        && (
                            <LeftNavigationItemCount
                                productCount={productCount}
                                selected={selected}
                            />
                        )}
                </div>
            </a>
            {
                isExpanded
                && (
                    <LeftNavigationItemGroup
                        isSubMenu
                        isCountHidden={isCountHidden}
                        items={children}
                        persistedFiltersGroup={persistedFiltersGroup}
                    />
                )
            }
        </li>
    );
}
